/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { Menu, Transition } from '@headlessui/react';
import React, { Fragment, useEffect, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { errorToast, getLocalStorageItem, isSuperAdmin, successToast } from '../utils/helper';
import { CompanyApi } from '../api/companyApi';
import { Api } from '../api';
import moment from 'moment';
import Smile1 from '../assets/images/sidebar/smile-1.svg';
import Smile2 from '../assets/images/sidebar/smile-2.svg';
import Smile3 from '../assets/images/sidebar/smile-3.svg';
import Smile4 from '../assets/images/sidebar/smile-4.svg';
import { RightSidebarData } from '../utils/pageContent';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
const RightSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [adminList, setAdminList] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [subsData, setSubsData] = useState(null);

  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const name = userData?.name?.split(' ');

  const getAdminList = () => {
    Api.getAdmins(1, 3, '', '', '', -1)
      .then((res) => {
        if (res?.data?.meta.code === 1) {
          setAdminList(res?.data?.data);
        } else {
          return errorToast(RightSidebarData.errorToastMessage);
        }
      })
      .catch((err) => {
        return errorToast(err);
      });
  };

  const getSubAdminList = () => {
    CompanyApi.getAdmins(1, 3, '', '', '', -1)
      .then((res) => {
        if (res?.data?.meta.code === 1) {
          setAdminList(res?.data?.data);
        } else {
          return errorToast(RightSidebarData.errorToastMessage);
        }
      })
      .catch((err) => {
        return errorToast(err);
      });
  };

  const getCompanyPlanData = () => {
    if (!userData.companyId) return;
    CompanyApi.getCompanyStatus(userData.companyId)
      .then((res) => {
        if (res?.data?.meta.code === 1) {
          setSubsData(res?.data?.data);
        } else {
          return errorToast(RightSidebarData.errorToastMessage);
        }
      })
      .catch((err) => {
        return errorToast(err);
      });
  };

  useEffect(() => {
    if (userData?.userType === 0 || userData?.userType === 1) {
      getAdminList();
    } else if (userData?.userType === 3 || userData?.userType === 4) {
      getSubAdminList();
    }
  }, []);

  useEffect(() => {
    getCompanyPlanData();
  }, [userData?.companyId]);

  useEffect(() => {
    if (!userData?.companyId) return;
    if (location.pathname.includes('/dashboard')) {
      Api.getCompanyData(userData?.companyId)
        .then((res) => {
          if (res?.data?.meta?.code === 1) {
            const company = res?.data?.data;
            setCompanyData({
              company_logo: company.company_logo,
              company_name: company.company_name,
              company_email: company.company_email,
              company_address: company.company_address,
              contact_person: company.contact_person,
              contact_number: company.contact_number,
              no_of_seat_bought: company.no_of_seat_bought,
              seat_price: company?.seat_price?.$numberDecimal
                ? parseFloat(company.seat_price.$numberDecimal).toFixed(2)
                : parseFloat(company?.seat_price || 0).toFixed(2),
              seat_active: company.seat_active,
              contract_progress: company.contract_progress,
              b2b_interest_via: company.b2b_interest_via,
              terms_agreed: company.terms_agreed,
              contract_sent: company.contract_sent,
              contract_signed: company.contract_signed,
              invoice_raised: company.invoice_raised,
              payment_complete: company.payment_complete,
              restrict_company: company.restrict_company,
              previousSeat: company.no_of_seat_bought,
              company_type: company.company_type,
              activeUsersCount: company.activeUsersCount,
              inactiveUsersCount: company.inactiveUsersCount
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [userData?.companyId]);

  const handleFeeling = (id) => {
    CompanyApi.addB2BMood({
      moodType: id
    })
      .then(() => successToast(RightSidebarData.moodRecordSuccessMessage))
      .catch(() => errorToast(RightSidebarData.errorToastMessage));
  };

  return (
    <>
      <div
        onClick={() => {
          navigate(`/${userData?.slug}/myCompany`);
        }}
        className="relative lg:hidden"
      >
        {companyData?.company_logo ? (
          <img
            loading="lazy"
            src={companyData.company_logo}
            className="w-10 h-10 object-cover rounded-full bg-blue-300"
          />
        ) : (
          <div className="self-center dark:bg-shoorah-darkBgColor bg-black flex justify-center items-center w-10 h-10 rounded-full">
            <span className="text-white">{name && name[0]?.charAt(0)}</span>
            <span className="text-white">{name && name[1]?.charAt(0)}</span>
          </div>
        )}
      </div>

      <div className="h-full relative hide-scrollbar overflow-y-scroll hidden lg:flex flex-col gap-y-4">
        {/* first box */}
        <div className="w-full border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor px-6 dark:border-none pt-4 pb-6 flex flex-col justify-center items-center rounded-2xl">
          <div className="flex justify-between items-start w-full">
            <div className="flex gap-4 items-center w-full relative">
              {companyData?.company_logo && !companyData.company_logo.includes('null') ? (
                <img
                  loading="lazy"
                  src={companyData.company_logo}
                  className="w-[47px] aspect-square object-cover rounded-full bg-blue-300"
                />
              ) : (
                <div className="self-center dark:bg-shoorah-darkBgColor bg-black flex justify-center items-center w-[47px] aspect-square rounded-full">
                  <span className="text-white font-medium">
                    {name && name[0]?.charAt(0).toUpperCase()}
                  </span>
                  <span className="text-white font-medium">
                    {name && name[1]?.charAt(0).toUpperCase()}
                  </span>
                </div>
              )}

              <div>
                <span className="font-bold text-base leading-5 dark:text-white mb-1 line-clamp-1 max-w-[100px]">
                  {userData?.name?.charAt(0).toUpperCase() + userData?.name?.slice(1)}
                </span>
                <div className="flex gap-1 text-left">
                  <h6 className="leading-[14px] text-shoorah-gray9 text-[12px] dark:text-white font-medium">
                    {userData?.userType === 3 || userData?.userType === 0
                      ? RightSidebarData.superAdmin
                      : userData?.userType === 5
                      ? RightSidebarData.partner
                      : RightSidebarData.subAdmin}
                  </h6>
                </div>
              </div>
            </div>
            <div className="text-base flex justify-center gap-x-1 items-center text-shoorah-newDashboardBlue2 dark:text-white">
              <Menu className="relative" as="div">
                <Menu.Button className="flex items-center justify-center text-sm font-medium focus:outline-none w-[18px] h-[18px] dark:border-white rounded-full border border-black mt-2">
                  <ChevronDownIcon className="w-[14px] dark:text-white/80 text-black" />
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute shadow-lg bottom-0 left-[3rem] -translate-x-full translate-y-full z-10 mt-2  rounded-md dark:bg-shoorah-darkBgColor bg-white ring-1 ring-shoorah-primary ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <Link
                            to={
                              !isSuperAdmin()
                                ? userData?.userType === 5
                                  ? '/change-password'
                                  : `/${userData.slug}/change-password`
                                : '/change-password'
                            }
                            className={classNames(
                              active
                                ? 'bg-gray-100 dark:text-white text-shoorah-sidebarBackground'
                                : ' dark:text-white text-gray-700',
                              'block px-4 py-2 whitespace-nowrap text-sm hover:bg-inherit'
                            )}
                          >
                            {RightSidebarData.changePassword}
                          </Link>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
          {(userData?.userType === 3 || userData?.userType === 4) && (
            <div className="w-full mt-6">
              <h4 className="text-[16px] leading-6 font-medium capitalize text-shoorah-newDashboardBlue2 dark:text-white">
                {userData?.companyName} {RightSidebarData.subscription}
              </h4>
              <p className="text-shoorah-gray2 text-xs leading-[18px] font-medium">
                {subsData && subsData?.account === 'Trial'
                  ? RightSidebarData.trialPlan
                  : subsData?.account === 'Subscribed'
                  ? RightSidebarData.subscribedPlan
                  : subsData?.account === 'Expired'
                  ? RightSidebarData.expiredPlan
                  : RightSidebarData.noSubscriptionPlan}
              </p>
            </div>
          )}

          <div className="w-full mt-6">
            <h4 className="text-[16px] leading-6 font-medium capitalize text-shoorah-newDashboardBlue2 dark:text-white">
              {RightSidebarData.aboutText} {userData?.companyName || RightSidebarData.companyName}
            </h4>
            <p className="text-shoorah-gray2 text-xs leading-[18px] font-medium">
              {RightSidebarData.aboutDescription}
            </p>
          </div>
        </div>

        {/* second box */}
        <div className="w-full px-8 py-6 border-[1.5px] dark:border-none border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor flex flex-col justify-center items-center rounded-2xl">
          <div className="w-full flex flex-col justify-center overflow-x-hidden">
            <h4 className="text-[16px] leading-6 font-medium capitalize text-shoorah-lightBlack dark:text-white mb-6">
              {RightSidebarData.otherAdminMember}
            </h4>
            {adminList?.length > 0 ? (
              <>
                <div className="flex flex-col w-full gap-y-4 mb-6">
                  {adminList.map((admin, index) => {
                    return (
                      <div key={index} className="flex items-center gap-2 w-full">
                        {admin?.userProfile && !admin?.userProfile.includes('null') ? (
                          <img
                            loading="lazy"
                            src={admin?.userProfile}
                            className="h-12 aspect-square rounded-full object-cover bg-shoorah-blue"
                          />
                        ) : (
                          <div className="h-12 flex items-center justify-center aspect-square rounded-full bg-black text-white capitalize">
                            {admin?.name?.charAt(0)}
                          </div>
                        )}
                        <div className="flex flex-col justify-center">
                          <h6 className="text-[16px] leading-6 font-medium text-shoorah-lightBlack2 dark:text-white mb-1 line-clamp-1">
                            {admin?.name}
                          </h6>
                          <p className="text-shoorah-darkGray leading-4 text-xs dark:text-shoorah-gray2 line-clamp-1">
                            {admin?.companyName || RightSidebarData.companyName}
                          </p>
                          <p className="text-shoorah-darkGray leading-4 text-xs dark:text-shoorah-gray2 line-clamp-1">
                            {RightSidebarData.lastLoginText}:{' '}
                            {admin?.lastLogin
                              ? moment(admin?.lastLogin).format('DD MMM YY')
                              : RightSidebarData.notActiveText}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <button
                  onClick={() => {
                    userData?.userType === 3 || userData?.userType === 4
                      ? navigate(`/${userData?.slug}/sub-admins`)
                      : navigate('/sub-admins');
                  }}
                  className="text-shoorah-gradient leading-6 text-[16px] font-medium text-left"
                >
                  {RightSidebarData.viewAllBtnText}
                </button>
              </>
            ) : (
              <div className="text-shoorah-gray2 text-xs">
                {RightSidebarData.onlyOneAdminMemberText}
              </div>
            )}
          </div>
        </div>

        {/* third box */}
        <div className="w-full px-8 py-6 border-[1.5px] dark:border-none border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor flex flex-col justify-center items-center rounded-2xl">
          <div className="justify-center gap-y-6 flex flex-col">
            <div className=" flex flex-col">
              <h4 className="text-[16px] leading-6 font-medium capitalize text-shoorah-lightBlack dark:text-white mb-2">
                {RightSidebarData.thirdBoxText.howAreYouFeeling}, {userData?.name}?
              </h4>
              <p className="text-shoorah-gray9 text-[12px] font-medium leading-[18px]">
                {RightSidebarData.thirdBoxText.thirdBoxDescription}
              </p>
            </div>
            <div>
              <div className="flex gap-2 text-2xl mb-5">
                <span onClick={() => handleFeeling(1)} className="cursor-pointer">
                  <img src={Smile1} alt="smile" />
                </span>
                <span onClick={() => handleFeeling(2)} className="cursor-pointer">
                  <img src={Smile2} alt="smile" />
                </span>
                <span onClick={() => handleFeeling(3)} className="cursor-pointer">
                  <img src={Smile3} alt="smile" />
                </span>
                <span onClick={() => handleFeeling(4)} className="cursor-pointer">
                  <img src={Smile4} alt="smile" />
                </span>
              </div>
              <p className="text-shoorah-lightBlack dark:text-white text-[12px] font-medium leading-6">
                {RightSidebarData.thirdBoxText.thirdBoxDescription2}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RightSidebar;
